import React, { ReactElement } from 'react'

import { ComponentsGroup, ComponentsGroupProps } from '../ComponentsGroup'

export type IconButtonsGroupProps = ComponentsGroupProps

export const IconButtonsGroup = ({ children, ...rest }: IconButtonsGroupProps): ReactElement => {
  return <ComponentsGroup {...rest}>{children}</ComponentsGroup>
}
